// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"e34c858d","621":"7150fe99","973":"3bafb61c"}[chunkId] + ".chunk.js";
};